import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import './Plan_lngPage.less';
import { Input, Select, Radio, DatePicker, Space, message } from 'antd';
import { Crud, Page, Upload } from '../../components';
import moment from 'moment';
import { config } from '../../utils/config';
import * as systemconfigActions from '../systemconfig/redux/actions';
import * as userActions from '../user/redux/actions';
const { SelectFile } = Upload;

const Option = Select.Option;
const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud;
const yesorno = [
  {
    value: '1',
    label: '否',
  },
  {
    value: '0',
    label: '是',
  },
];
export class Plan_lngPage extends Component {
  static pro
  pTypes = {
    plan: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    qpStructure: '',
    qpName: '',
    mediumname: '',
    lb: '',
    pbz: '',
    rj: '',
    jyzqSj: '',
    gzyl: '',
    hdNd: '',
    hdMyNd: '',
    lifeSj: '',
    zjNd: '',
    syylNd: '',
    aqkj: '',
    qpCode: '',

    // 制造单位代码
    numLic: '',
    // 制造监检单位-编码
    igasvidZzjj: '',
    zzLicImage: ''
  };
  componentDidMount() {
    const { plan_lngPage, currentPlan_lng } = this.props.plan;
    const { getAllQpxlList, getAllMakeJjdwActions } = this.props.actions;
    const { getDictionariesList } = this.props.systemconfigActions;
    const { getTempFileListAction, getFrui_qppzList } = this.props.userActions
    getTempFileListAction()
    // 字典
    getDictionariesList();
    // 所有的气瓶型号信息 不分页
    getAllQpxlList();
    // 制造监检单位
    getAllMakeJjdwActions()
    this.fetchList(plan_lngPage);
    // 气瓶品种筛选
    getFrui_qppzList({ page: 1, size: 999 });
  }

  fetchList = (page) => {
    const { getPlan_lngList } = this.props.actions;
    let otherParams = {
      noPh: this.noPh,
      qpCode: this.qpCode
    }

    let params = Object.assign({}, { page: page , orderBy: 'insert_time'  }, otherParams);
    getPlan_lngList(params);
  };

  getDataSource() {
    const { plan } = this.props;
    const { plan_lngById, plan_lngList } = plan;
    if (!plan_lngList) return [];
    return plan_lngList.map(id => plan_lngById[id]);
  }

  selectRow = (record) => {
    console.log(record)
    const { plan, actions } = this.props;
    const { chooseCurrentPlan_lng } = actions;
    chooseCurrentPlan_lng(record);
  }

  get listProps() {
    const { plan, actions } = this.props;
    const { getPlan_lngListPending, plan_lngTotal, plan_lngPage, plan_lngList } = plan;
    const {
      deletePlan_lng,
      chooseCurrentPlan_lng,
      plan_lngModalChange,
      fileNameActions,
      certificateCompileModalChange,
      qualityProveModalChange,
      certificateCompileId,
      qualityProveId,
      mediumSafetyUploadingChoose,
      qpdataFileUploadingChoose,
      getAllbatchActions,
      chooseCurrentQpxh,
      getGenerateActions,
      getCheckActions,
      qpParamsFileUploadChoose
    } = actions;
    // 型式试验预览
    const xssyzsOssnameYL = (record) => {
      if (record.xssyzsOssname) {
        // window.open(`https://furuiapi.zhelut.com${record.xssyzsOssname}`);
        window.open(`${config.attachUrl}${record.xssyzsOssname}`)
      } else {
        message.error('请上传型式试验')
      }
    }

    //监检证书编辑
    const zzjjzsOssnameBJ = (record) => {
      certificateCompileModalChange(true);
      certificateCompileId(record.id);
      getAllbatchActions(record.id);
    }
    // 监检证书预览
    const zzjjzsOssnameYL = (record) => {
      if (record.zzjjzsOssname) {
        // window.open(`https://furuiapi.zhelut.com${record.zzjjzsOssname}`);
        window.open(`${config.attachUrl}${record.zzjjzsOssname}`)
      } else {
        message.error('请上传监检证书')
      }
    }
    //质量证明编辑
    const zlzmsOssnameBJ = (record) => {
      qualityProveModalChange(true);
      qualityProveId(record.id);
      getAllbatchActions(record.id);
    }
    // 质量证明预览
    const zlzmsOssnameYL = (record) => {
      if (record.zlzmsOssname) {
        // window.open(`https://furuiapi.zhelut.com${record.zlzmsOssname}`);
        window.open(`${config.attachUrl}${record.zlzmsOssname}`)
      } else {
        message.error('请上传质量证明文件');
      }
    }

    // 气瓶维护生成
    const QPcreateSC = (record) => {
      getGenerateActions(record.id).then(res => {
        if (res.code === 200) {
          message.success('成功');
        } else {
          message.error('失败');
        }
      });
    }
    //  气瓶维护查阅
    const QPcreateCY = (record) => {
      getCheckActions(record.id).then(res => {
        message.success(`已生成气瓶数: ${res.data.count}`);
      });
    }

    // 产品使用手册上传
    const mediumsheetOssnameSC = (record) => {
      mediumSafetyUploadingChoose(true, record.id);
    }

    // 产品数据表  生成操作
    const qpdataFile = record => {
      const { buildqpdataFileAction } = this.props.actions;
      buildqpdataFileAction(record.id).then(res => {
        message.info('生成成功')
        this.fetchList(plan_lngPage);
      });
    }

    // 产品数据表预览
    const qpdataFileYL = record => {
      console.log('qpDataFile', record);
      if (record.qpDataFile) {
        console.log(`${config.attachUrl}${record.qpDataFile}`)
        window.open(`${config.attachUrl}${record.qpDataFile}`);
      } else {
        message.error('请生成产品数据表');
      }
    }

    // 气瓶参数文件
    const qpParamsFileYL = record => {
      if (record.qpParamFile) {
        window.open(`${config.attachUrl}${record.qpParamFile}`);
      } else {
        message.error('请上传气瓶附件文件');
      }
    }
    const qpParamsFile = (record) => {
      const { qpParamsFileUploadChoose } = this.props.actions;
      qpParamsFileUploadChoose(true, record.id);
    }

    // 产品使用手册预览
    const mediumsheetOssnameYL = (record) => {
      if (record.mediumsheetOssname) {
        // window.open(`https://furuiapi.zhelut.com${record.mediumsheetOssname}`);
        window.open(`${config.attachUrl}${record.mediumsheetOssname}`);
      } else {
        message.error('请上传产品使用手册');
      }
    }
    return {
      dataSource: this.getDataSource(),
      loading: getPlan_lngListPending,
      scroll: { x: 1300 },
      columns: [
        {
          title: '批号',
          dataIndex: 'noPh',
          key: 'noPh',
          width: 180,
        }, {
          title: '气瓶品种',
          dataIndex: 'qpName',
          key: 'qpName',
          width: 180,
        },
        {
          title: '内胆批号',
          dataIndex: 'noPhNd',
          key: 'noPhNd',
          width: 180,
        },
        {
          title: '气瓶型号',
          dataIndex: 'typeName',
          key: 'typeName',
          width: 180,
        },
        {
          title: '充装介质',
          dataIndex: 'mediumname',
          key: 'mediumname',
          width: 180,
        },
        {
          title: '制造日期',
          dataIndex: 'pdate',
          key: 'pdate',
          width: 180,
          render: text => {
            if (text != undefined) {
              return <div>{moment(text).format('YYYY-MM')}</div>;
            } else {
              return <div></div>;
            }
          },
        },
        {
          title: '内胆设计壁度',
          dataIndex: 'hdNd',
          key: 'hdNd',
          width: 180,
        },
        {
          title: '内胆直径',
          dataIndex: 'zjNd',
          key: 'zjNd',
          width: 180,
        },
        {
          title: '内胆气压试验压力',
          dataIndex: 'syylNd',
          key: 'syylNd',
          width: 180,
        },
        {
          title: '产品编号开始',
          dataIndex: 'pidS',
          key: 'pidS',
          width: 180,
        },
        {
          title: '产品编号结束',
          dataIndex: 'pidE',
          key: 'pidE',
          width: 180,
        },



        {
          title: '型式试验',
          dataIndex: 'xssyzsOssname',
          key: 'xssyzsOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => xssyzsOssnameYL(record)}>预览</a>
            </div>
          }
        },
        {
          title: '监检证书',
          dataIndex: 'zzjjzsOssname',
          key: 'zzjjzsOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => zzjjzsOssnameYL(record)}>预览  &nbsp; &nbsp; &nbsp; </a>
              <a onClick={() => zzjjzsOssnameBJ(record)}>编辑</a>
            </div>
          }
        },
        {
          title: '质量证明',
          dataIndex: 'zlzmsOssname',
          key: 'zlzmsOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => zlzmsOssnameYL(record)}>预览 &nbsp; &nbsp; &nbsp; </a>
              <a onClick={() => zlzmsOssnameBJ(record)}>编辑</a>
            </div>
          }
        },
        {
          title: '气瓶维护',
          dataIndex: 'id',
          key: 'id',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => QPcreateSC(record)}>生成 &nbsp; &nbsp; &nbsp; </a>
              <a onClick={() => QPcreateCY(record)}>查阅</a>
            </div>
          }
        },
        {
          title: '产品使用手册',
          dataIndex: 'mediumsheetOssname',
          key: 'mediumsheetOssname',
          width: 180,
          render: (text, record) => {
            return <div>
              <a onClick={() => mediumsheetOssnameYL(record)}>预览 &nbsp; &nbsp; &nbsp; </a>
              <a onClick={() => mediumsheetOssnameSC(record)}>上传</a>
            </div>
          }
        }, {
          title: '产品数据表',
          dataIndex: 'qpDataFile',
          key: 'qpDataFile',
          width: 180,
          render: (txt, record) => {
            //window.open(`${config.attachUrl}${record.qpDataFile}`);
            if (record.qpDataFile) {
              let downlaoUrl = `${config.attachUrl}${record.qpDataFile}`;
              return <div>
                <a href={downlaoUrl}>预览 &nbsp; &nbsp; &nbsp;</a>
                <a onClick={() => qpdataFile(record)}>生成</a>
              </div>
            } else {
              return <div>
                <a onClick={() => qpdataFile(record)}>生成</a>
              </div>
            }


          }
        }, {
          title: '气瓶附件文件',
          dataIndex: 'qpParamFile',
          key: 'qpParamFile',
          width: 180,
          render: (txt, record) => {
            return <div>
              <a onClick={() => qpParamsFileYL(record)}>预览 &nbsp; &nbsp; &nbsp;</a>
              <a onClick={() => qpParamsFile(record)}>上传</a>
            </div>
          }
        }
      ],
      pagination: {
        total: plan_lngTotal,
        current: plan_lngPage,
        onChange: page => {
          this.fetchList(page);
        },
      },
      op: [
        {
          key: 1,
          name: '编辑',
          buttonProps: {
            icon: 'edit',
            type: 'primary',
          },
        },
        {
          key: 3,
          name: '删除',
          buttonProps: {
            icon: 'delete',
            type: 'danger',
          },
          needConfirm: true,
          confirmTitle: '确认删除',
        },
      ],
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          // 获取当前主键ID的气瓶型号，回显数据
          chooseCurrentQpxh(record.typeName)
          console.log(record.typeName)
          chooseCurrentPlan_lng(record);
          plan_lngModalChange(true, 'updata');
        } else if (item.key === 3) {
          deletePlan_lng(record.id).then(data => {
            console.log(data);
            if (data.code === 400) {
              message.error(`${data.message}`);
            } else {
              this.fetchList(plan_lngPage);
            }
          });
        } else if (item.key === 2) {

        } else if (item.key === 8) {
        } else if (item.key === 9) {
        } else if (item.key === 11) {

        }
      },
    };
  }
  // 产品使用手册上传
  get modalMediumSafety() {
    const { actions, plan } = this.props;
    const { mediumSafetyUploadingChoose, mediumSafetyUploadingActions } = actions;
    const {
      mediumSafetyUploadingVisible,
      mediumSafetyUploadingId,
      plan_lngPage,
      mediumSafetyUploadingActionsPending,
      getAllBatch,
    } = plan;
    let editItem = getAllBatch === undefined ? {} : getAllBatch;
    return {
      visible: mediumSafetyUploadingVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: mediumSafetyUploadingActionsPending,
      title: '产品使用手册',
      centered: true,
      elements: [
        {
          key: 'file',
          label: '上传文件',
          initialValue: editItem === undefined ? [] : editItem.mediumsheetOssname,
          widget: SelectFile,
          widgetProps: {},
        },
      ],
      onOk: data => {
        let params = new FormData();
        params.append('file', data.file);
        mediumSafetyUploadingActions(params, mediumSafetyUploadingId).then(res => {
          mediumSafetyUploadingChoose(false);
          this.fetchList(plan_lngPage);
        });
      },
      onCancel() {
        mediumSafetyUploadingChoose(false);
      },
    };
  }

  // 气瓶附件文件
  get modalQpParamsFile() {
    const { plan, actions } = this.props;
    const { qpParamsFileUploadingAction, qpParamsFileUploadChoose } = actions;
    const {
      qpParamsFileUploadingId,
      qpParamsFileUploadingActionPending,
      qpParamsFileUploadingVisible,
      currentPlan_lng,
      plan_lngPage
    } = plan;
    let editItem = currentPlan_lng === undefined ? {} : currentPlan_lng;

    return {
      visible: qpParamsFileUploadingVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: qpParamsFileUploadingActionPending,
      title: '气瓶附件文件',
      centered: true,
      elements: [
        {
          key: 'file',
          label: '上传文件',
          initialValue: editItem === undefined ? [] : editItem.qpParamFile,
          widget: SelectFile,
          widgetProps: {},
        }
      ],
      onOk: data => {
        let params = new FormData();
        params.append('file', data.file);
        qpParamsFileUploadingAction(params, qpParamsFileUploadingId, false).then(res => {
          qpParamsFileUploadChoose(false);
          this.fetchList(plan_lngPage);
        });
      },
      onCancel() {
        qpParamsFileUploadChoose(false);
      },
    };

  }


  // 监检证书编辑
  get modalPropsCertificate() {
    const { plan, actions } = this.props;
    const { certificateCompileActions, certificateCompileModalChange } = actions;
    const {
      certificateCompileModalVisible,
      getAllBatch,
      certificateCompileActionsPending,
      certificateCompilesId,
      plan_lngPage,
    } = plan;
    let editItem = getAllBatch === undefined ? {} : getAllBatch;
    return {
      visible: certificateCompileModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: certificateCompileActionsPending,
      title: '编辑',
      centered: true,
      elements: [
        {
          key: 'file',
          label: '上传文件',
          initialValue: editItem == undefined ? [] : editItem.file,
          widget: SelectFile,
          widgetProps: {},
        },
        {
          key: 'nameZzjj',
          label: '制造监督检验机构',
          initialValue: editItem == undefined ? '' : editItem.nameZzjj,
          widget: Input,
          disabled: true,
        },
        {
          key: 'dateZzjj',
          label: '证书日期',
          initialValue: editItem == undefined ? '' : moment(editItem.dateZzjj),
          widget: DatePicker,
        },
        {
          key: 'jjZzjj',
          label: '监检',
          initialValue: editItem == undefined ? '' : editItem.jjZzjj,
          widget: Input,
        },
        {
          key: 'noZzjj',
          label: '证书编号',
          initialValue: editItem == undefined ? '' : editItem.noZzjj,
          widget: Input,
        },
        {
          key: 'pzZzjj',
          label: '批准',
          initialValue: editItem == undefined ? '' : editItem.pzZzjj,
          widget: Input,
        },
        {
          key: 'shZzjj',
          label: '审核',
          initialValue: editItem == undefined ? '' : editItem.shZzjj,
          widget: Input,
        },
      ],
      onOk: data => {
        console.log(data);
        let params = new FormData();
        params.append('dateZzjj', data.dateZzjj);
        params.append('jjZzjj', data.jjZzjj ? data.jjZzjj : '');
        params.append('nameZzjj', data.nameZzjj ? data.nameZzjj : '');
        params.append('noZzjj', data.noZzjj ? data.noZzjj : '');
        params.append('pzZzjj', data.pzZzjj ? data.pzZzjj : '');
        params.append('shZzjj', data.shZzjj ? data.shZzjj : '');
        params.append('file', data.file);
        params.append('id', certificateCompilesId);
        certificateCompileActions(params).then(res => {
          certificateCompileModalChange(false);
          this.fetchList(plan_lngPage);
        });
      },
      onCancel() {
        certificateCompileModalChange(false);
      },
    };
  }
  // 质量证明书
  get modalPropsQuality() {
    const { plan, actions } = this.props;
    const { qualityProveCompileActions, qualityProveModalChange } = actions;
    const {
      qualityProveModalvisible,
      getAllBatch,
      qualityProveCompileActionsPending,
      qualityProvesId,
      plan_lngPage,
    } = plan;
    let editItem = getAllBatch === undefined ? {} : getAllBatch;
    return {
      visible: qualityProveModalvisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: qualityProveCompileActionsPending,
      title: '编辑',
      centered: true,
      elements: [
        {
          key: 'file',
          label: '上传文件',
          initialValue: editItem == undefined ? [] : editItem.file,
          widget: SelectFile,
          widgetProps: {},
        },
        {
          key: 'dateZlzm',
          label: '证书日期',
          initialValue: editItem == undefined ? '' : moment(editItem.dateZlzm),
          widget: DatePicker,
        },
        {
          key: 'datejjZlzm',
          label: '监检日期',
          initialValue: editItem == undefined ? '' : moment(editItem.datejjZlzm),
          widget: DatePicker,
        },
        {
          key: 'jjZlzm',
          label: '监检',
          initialValue: editItem == undefined ? '' : editItem.jjZlzm,
          widget: Input,
        },
        {
          key: 'nameZlzmZd',
          label: '内胆制造单位',
          initialValue: editItem == undefined ? '' : editItem.nameZlzmZd,
          widget: Input,
        },
        {
          key: 'noZlzm',
          label: '质量证书编号',
          initialValue: editItem == undefined ? '' : editItem.noZlzm,
          widget: Input,
        },
        {
          key: 'pzZlzm',
          label: '批准',
          initialValue: editItem == undefined ? '' : editItem.pzZlzm,
          widget: Input,
        },
        {
          key: 'shZlzm',
          label: '审核',
          initialValue: editItem == undefined ? '' : editItem.shZlzm,
          widget: Input,
        },
      ],
      onOk: data => {
        let params = new FormData();
        params.append('file', data.file);
        params.append('id', qualityProvesId);
        params.append('dateZlzm', data.dateZlzm);
        params.append('datejjZlzm', data.datejjZlzm);
        params.append('jjZlzm', data.jjZlzm);
        params.append('nameZlzmZd', data.nameZlzmZd);
        params.append('noZlzm', data.noZlzm);
        params.append('pzZlzm', data.pzZlzm);
        params.append('shZlzm', data.shZlzm);
        qualityProveCompileActions(params).then(res => {
          qualityProveModalChange(false);
          this.fetchList(plan_lngPage);
        });
      },
      onCancel() {
        qualityProveModalChange(false);
      },
    };
  }

  // 标签模板
  gethandleTemplate = () => {
    const { tempFilesById, tempFilesList } = this.props.user
    // console.log()
    return tempFilesList.map(item => tempFilesById[item]).map(item => {
      //  console.log(item)
      if (item.type === 1) {
        return <Option key={item.name}>{item.name}</Option>
      }
    })
  };

  // 合格证模板
  gethandleHgz = () => {
    const { tempFilesById, tempFilesList } = this.props.user
    // console.log()
    return tempFilesList.map(item => tempFilesById[item]).map(item => {
      if (item.type === 2) {
        return <Option key={item.name}>{item.name}</Option>
      }
    })
  };

  //  产品类别
  gethandleType = () => {
    const { getgetDictionariesMap } = this.props.systemconfig;
    let arr = getgetDictionariesMap[21];
    if (arr) {
      return arr.dictDetails.map(item => <Option key={item.value}>{item.value}</Option>);
    }
  };

  // 制造监检单位
  gethandleZzjcdw = () => {
    const { getAllMakeJjdwList, getAllMakeJjdwId } = this.props.plan;
    console.log(getAllMakeJjdwList, getAllMakeJjdwId)
    return getAllMakeJjdwList.map(id => getAllMakeJjdwId[id]).map(item => (
      <Option key={item.nameJc}>{item.nameJc}</Option>
    ))
  };
  // 制造监检单位回调
  handleChangeZzjcdw = res => {
    const { getAllMakeJjdwList, getAllMakeJjdwId } = this.props.plan;
    let List = []
    List.push(res)
    let object = {}
    //  变成 map 找到对应的对象
    getAllMakeJjdwList.map(id => getAllMakeJjdwId[id]).map(item => object[item.nameJc] = item)
    console.log(object)
    List.map(id => object[id]).map(item => (
      this.setState({
        numLic: item.noLic,
        igasvidZzjj: item.igasvID
      })
    ))
  };

  // 气瓶型号
  gethandleTypeName = () => {
    const { getAllQpxlListId, getAllQpxlListList } = this.props.plan;
    return getAllQpxlListList
      .map(id => getAllQpxlListId[id])
      .map(item => (
        // console.log(item)
        <Option key={item.typeName}>{item.typeName}</Option>
      ));
  };
  handleOnchangetypeName = res => {
    console.log(res);
    let arr = [];
    arr.push(res);
    const { getAllQpxlListId, getAllQpxlListList } = this.props.plan;
    let object = {};
    getAllQpxlListList.map(id => getAllQpxlListId[id]).map(item => (object[item.typeName] = item));
    return arr.map(item => object[item]).map(items => (
      console.log(items, 'item'),
      this.setState({
        qpStructure: items.qpStructure,
        qpName: items.qpName,
        mediumname: items.mediumname,
        lb: items.lb,
        pbz: items.pbz,
        rj: items.rj,
        jyzqSj: items.jyzqSj,
        gzyl: items.gzyl,
        hdNd: items.hdNd,
        hdMyNd: items.hdMyNd,
        lifeSj: items.life,
        zjNd: items.zjNd,
        syylNd: items.syylNd,
        aqkj: items.aqkj,
        zl: items.zl,
        czlMax: items.czlMax,
        fillingmediumcode: items.fillingmediumcode,
        qpCode: items.qpCode
      })
    ));
  };

  // 制造许可证编号
  gethandlezzLic = () => {
    const { getgetDictionariesMap } = this.props.systemconfig;
    let arr = getgetDictionariesMap[23];
    if (arr) {
      return arr.dictDetails.map(item => <Option key={item.label}>{item.label}</Option>);
    }
  }
  handleChangezzLic = res => {
    let arr = []
    let byId = {}
    arr.push(res)
    const { getgetDictionariesMap } = this.props.systemconfig;
    let zzLicList = getgetDictionariesMap[23];
    zzLicList.dictDetails.map(item => byId[item.label] = item)
    console.log(byId)
    arr.map(item => byId[item]).map(item =>
      this.setState({
        zzLicImage: item.value
      })
    )
  }
  get modalProps() {
    const { plan, actions } = this.props;
    const {
      currentPlan_lng,
      plan_lngModalVisible,
      plan_lngPage,
      plan_lngModalType,
      submitPlan_lngPending,
    } = plan;

    const { plan_lngModalChange, submitPlan_lng, chooseCurrentPlan_lng,

     } = actions;
    let editItem = plan_lngModalType === 'create' ? {} : currentPlan_lng;
    return {
      item: plan_lngModalType === 'create' ? {} : currentPlan_lng,
      visible: plan_lngModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitPlan_lngPending,
      title: `${plan_lngModalType === 'create' ? `创建` : `更新`}`,
      centered: true,
      elements: [
        {
          key: 'noPh',
          label: '生产批号',
          initialValue: editItem.noPh,
          widget: Input,
          required: true,
          disabled: editItem.id ? true : false,
        },
        {
          key: 'slPh',
          label: '数量',
          initialValue: editItem.slPh,
          widget: Input,
          required: true,
        },
        {
          key: 'typeName',
          label: '气瓶型号',
          initialValue: editItem.typeName,
          widget: Select,
          required: true,
          widgetProps: {
            onChange: res => this.handleOnchangetypeName(res),
          },

          children: this.gethandleTypeName(),
        },
        {
          key: 'qpstructure',
          label: '气瓶结构',
          initialValue: this.state.qpStructure || editItem.qpstructure,
          widget: Input,
        },
        {
          key: 'qpCode',
          label: '气瓶品种',
          initialValue: this.state.qpCode || editItem.qpCode,
          widget: Input,
        },
        {
          key: 'qpName',
          label: '气瓶品种名称',
          initialValue: this.state.qpName || editItem.qpName,
          widget: Input,
          required: true,
        },
        {
          key: 'lb',
          label: '类别',
          initialValue: this.state.lb || editItem.lb,
          widget: Select,
          children: this.gethandleType(),
        },
        {
          key: 'pbz',
          label: '产品标准',
          initialValue: this.state.pbz || editItem.pbz,
          widget: Input,
          required: true,
        },
        {
          key: 'unitname',
          label: '制造单位名称',
          initialValue: this.state.unitname || editItem.unitname,
          widget: Input,
          required: true,
        },
        {
          key: 'noLic',
          label: '制造许可证',
          initialValue: this.state.noLic || editItem.noLic,
          widget: Input,
          required: true,
        },
        {
          key: 'pdate',
          label: '制造日期',
          initialValue: moment(editItem.pdate),
          widget: DatePicker,
          required: true,
        },
        {
          key: 'pidS',
          label: '产品编号开始',
          initialValue: editItem.pidS,
          widget: Input,
          required: true,
        },
        {
          key: 'pidE',
          label: '产品编号结束',
          initialValue: editItem.pidE,
          widget: Input,
          required: true,
        },
        {
          key: 'traceIdS',
          label: '唯一追溯编号开始',
          initialValue: editItem.traceIdS,
          widget: Input,
          required: true,
        },
        {
          key: 'traceIdE',
          label: '唯一追溯编号结束',
          initialValue: editItem.traceIdE,
          widget: Input,
          required: true,
        },
        {
          key: 'noPhNd',
          label: '内胆批号',
          initialValue: editItem.noPhNd !== undefined ? editItem.noPhNd : '',
          widget: Input,
          required: true,
        },
        {
          key: 'aqkj',
          label: '安全空间',
          initialValue: this.state.aqkj || editItem.aqkj,
          widget: Input,
        },
        {
          key: 'rj',
          label: '公称容积',
          initialValue: this.state.rj || editItem.rj,
          widget: Input,
        },
        {
          key: 'jyzqSj',
          label: '定期检验周期',
          initialValue: this.state.jyzqSj || editItem.jyzqSj,
          widget: Input,
        },
        {
          key: 'lifeSj',
          label: '使用年限',
          initialValue: this.state.lifeSj || editItem.lifeSj,
          widget: Input,
        },
        {
          key: 'gzyl',
          label: '工作压力',
          initialValue: this.state.gzyl || editItem.gzyl,
          widget: Input,
        },
        {
          key: 'hdNd',
          label: '内胆设计壁厚',
          initialValue: this.state.hdNd || editItem.hdNd,
          widget: Input,
        },
        {
          key: 'hdMyNd',
          label: '内胆名义厚度',
          initialValue: this.state.hdMyNd || editItem.hdMyNd,
          widget: Input,
        },
        {
          key: 'zjNd',
          label: '内胆直径',
          initialValue: this.state.zjNd || editItem.zjNd,
          widget: Input,
        },
        {
          key: 'mediumname',
          label: '充装介质',
          initialValue: this.state.mediumname || editItem.mediumname,
          widget: Input,
        },
        {
          key: 'pfZl',
          label: '增量电容值',
          initialValue: editItem.pfZl !== undefined ? editItem.pfZl : '',
          widget: Input,
        },
        {
          key: 'zzLic',
          label: '制造许可证编号',
          initialValue: editItem.zzLic,
          widget: Select,
          widgetProps: {
            onChange: res => this.handleChangezzLic(res),
          },
          children: this.gethandlezzLic(),
        },
        {
          key: 'zzLicImage',
          label: '制造许可证文件',
          initialValue: this.state.zzLicImage || editItem.zzLicImage,
          widget: Input,
          disabled: true
        },
        {
          key: 'nameZzjj',
          label: '制造监检单位',
          initialValue: editItem.nameZzjj,
          widget: Select,
          widgetProps: {
            onChange: res => this.handleChangeZzjcdw(res),
          },
          children: this.gethandleZzjcdw(),
        },
        {
          key: 'igasvidZzjj',
          label: '制造监检单位-编码',
          initialValue: this.state.igasvidZzjj || editItem.igasvidZzjj,
          widget: Input,
        },
        {
          key: 'numLic',
          label: '制造单位代码',
          initialValue: this.state.numLic || editItem.numLic,
          widget: Input,
        },


        {
          key: 'pidBqTemp',
          label: '标签模板',
          initialValue: editItem.pidBqTemp !== undefined ? editItem.pidBqTemp : '',
          widget: Select,
          children: this.gethandleTemplate(),
          required: true,
        },
        {
          key: 'pidHgTemp',
          label: '合格证模板',
          initialValue: editItem.pidHgTemp !== undefined ? editItem.pidHgTemp : '',
          widget: Select,
          children: this.gethandleHgz(),
          required: true,
        },
        {
          key: 'cCl',
          label: 'c<=',
          initialValue: editItem.cCl !== undefined ? editItem.cCl : ' 0.08',
          widget: Input,
        },
        {
          key: 'mnCl',
          label: 'mn<=',
          initialValue: editItem.mnCl !== undefined ? editItem.mnCl : '2',
          widget: Input,
        },
        {
          key: 'pCl',
          label: 'p<=',
          initialValue: editItem.pCl !== undefined ? editItem.pCl : '0.035',
          widget: Input,
        },
        {
          key: 'sCl',
          label: 's<=',
          initialValue: editItem.sCl !== undefined ? editItem.sCl : '0.03',
          widget: Input,
        },
        {
          key: 'siCl',
          label: 'si<=',
          initialValue: editItem.siCl !== undefined ? editItem.siCl : '1',
          widget: Input,
        },
        {
          key: 'niCl',
          label: 'Ni<=',
          initialValue: editItem.niCl !== undefined ? editItem.niCl : '8~11',
          widget: Input,
        },
        {
          key: 'crCl',
          label: 'cr<=',
          initialValue: editItem.crCl !== undefined ? editItem.crCl : '17~20',
          widget: Input,
        },

        {
          key: 'pcnumPh',
          label: '本批次不包括编号',
          initialValue: editItem.pcnumPh,
          widget: Input,
        },
        {
          key: 'zl',
          label: '气瓶净重',
          initialValue: this.state.zl || editItem.zl,
          widget: Input,
        },
        {
          key: 'czlMax',
          label: '最大充装量',
          initialValue: this.state.czlMax || editItem.czlMax,
          widget: Input,
          required: true,
        },
        {
          key: 'fillingmediumcode',
          label: '填充介质代码',
          initialValue: this.state.fillingmediumcode || editItem.fillingmediumcode,
          widget: Input,
          required: true
        },
        {
          key: 'syylNd',
          label: '内胆气压试验压力',
          initialValue: this.state.syylNd || editItem.syylNd,
          widget: Input,
        },
        {
          key: 'rcodeGy',
          label: '气瓶电子标识是否与气瓶钢印截图相同',
          initialValue: editItem.rcodeGy,
          widget: Radio.Group,
          widgetProps: {
            options: yesorno,
          },
          required: true,
        },
      ],
      onOk: data => {
        let params = {
          aqkj: data.aqkj,
          cCl: data.cCl,
          noPh: data.noPh,
          slPh: data.slPh,
          typeName: data.typeName,
          qpstructure: data.qpstructure,
          qpCode: data.qpCode,
          qpName: data.qpName,
          lb: data.lb,
          pbz: data.pbz,
          pdate: data.pdate.format('YYYY-MM-DD'),
          pidS: data.pidS,
          pidE: data.pidE,
          pcnumPh: data.pcnumPh,
          rj: data.rj,
          jyzqSj: data.jyzqSj,
          lifeSj: data.lifeSj,
          gzyl: data.gzyl,
          hdNd: data.hdNd,
          hdMyNd: data.hdMyNd,
          zjNd: data.zjNd,
          syylNd: data.syylNd,
          rcodeGy: data.rcodeGy,
          mediumname: data.mediumname,
          fillingmediumcode: data.fillingmediumcode,
          pfZl: data.pfZl,
          numLic: data.numLic,
          igasvidZzjj: data.igasvidZzjj,
          nameZzjj: data.nameZzjj,
          noPhNd: data.noPhNd,
          qpname_jc: data.qpname_jc,
          pidBqTemp: data.pidBqTemp,
          pidHgTemp: data.pidHgTemp,
          mnCl: data.mnCl,
          pCl: data.pCl,
          sCl: data.sCl,
          siCl: data.siCl,
          niCl: data.niCl,
          numLic: data.numLic,
          crCl: data.crCl,
          zl: data.zl,
          czlMax: data.czlMax,
          sn_qpcode: data.sn_qpcode,
          sn_gg: data.sn_gg,
          id: editItem !== undefined ? editItem.id : '',
          traceIdS: data.traceIdS,
          traceIdE: data.traceIdE,
          zzLic: data.zzLic,
          zzLicImage: this.state.zzLicImage || data.zzLicImage,
          unitname: data.unitname,
          noLic: data.noLic
        };
        submitPlan_lng(params).then(data => {
          console.log(data);
          if (data.code === 400) {
            plan_lngModalChange(false, 'create');
            message.error(`${data.message}`);
          }
          chooseCurrentPlan_lng(params);
          plan_lngModalChange(false, 'create');
          this.fetchList(plan_lngPage);
          this.setState({
            qpStructure: '',
            qpName: '',
            mediumname: '',
            lb: '',
            pbz: '',
            rj: '',
            jyzqSj: '',
            gzyl: '',
            hdNd: '',
            hdMyNd: '',
            lifeSj: '',
            zjNd: '',
            syylNd: '',
            aqkj: '',
            zl: '',
            czlMax: '',
            fillingmediumcode: '',
            qpCode: '',
            numLic: '',
            igasvidZzjj: '',
            zzLicImage: '',
          })
        });
      },
      onCancel: () => {
        this.setState({
          qpStructure: '',
          qpName: '',
          mediumname: '',
          lb: '',
          pbz: '',
          rj: '',
          jyzqSj: '',
          gzyl: '',
          hdNd: '',
          hdMyNd: '',
          lifeSj: '',
          zjNd: '',
          syylNd: '',
          aqkj: '',
          zl: '',
          czlMax: '',
          fillingmediumcode: '',
          qpCode: '',
          numLic: '',
          igasvidZzjj: '',
          zzLicImage: '',
        }, () => {
        })
        plan_lngModalChange(false, 'create');
      },
    };
  }

  choosePqpz = () => {
    let { user } = this.props;
    const { frui_qppzById, frui_qppzList } = user;
    return frui_qppzList.map(id => frui_qppzById[id]).map(item => <Option key={item.qpCode}>{item.qpName}</Option>)
  }

  get filterProps() {
    const { actions, plan } = this.props;
    // const { currentPlan_lng, plan_lngPage } = plan
    const { plan_lngModalChange } = actions;

    return {
      title: '',
      searchElements: [
        {
          key: 'noPh',
          widget: Input,
          widgetProps: {
            placeholder: '请输入批号',
          },
        },
        {
          key: "qpCode",
          widget: Select,
          widgetProps: {
            style: { width: 200 },
            placeholder: "气瓶品种",
          },
          children: this.choosePqpz()
        }
      ],
      onFilterChange: value => {
        this.noPh = value.noPh;
        this.qpCode = value.qpCode;
        this.fetchList(1);
      },
      onAdd() {
        plan_lngModalChange(true, 'create');
      },
    };
  }

  get buttonProps() {
    const { actions, plan } = this.props;
    const { currentPlan_lng, plan_lngPage } = plan;
    const { plan_lngModalChange, chooseCurrentPlan_lng, getGenerateActions, getCheckActions, } = actions;

    return {
      buttons: [
        {
          name: '新增',
          buttonProps: {
            type: 'primary',
          },
          onClick: () => {
            plan_lngModalChange(true, 'create');
          },
        },
        // {
        //   name: '导出',
        //   buttonProps: {
        //     type: 'primary',
        //     icon: 'plus',
        //   },
        //   onClick: () => {
        //     message.info('待完善')
        //   },
        // },
      ],
    };
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
        <CrudForm {...this.modalPropsCertificate} />
        <CrudForm {...this.modalPropsQuality} />
        <CrudForm {...this.modalMediumSafety} />
        <CrudForm {...this.modalQpParamsFile} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    plan: state.plan,
    systemconfig: state.systemconfig,
    user: state.user
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    systemconfigActions: bindActionCreators({ ...systemconfigActions }, dispatch),
    userActions: bindActionCreators({ ...userActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Plan_lngPage);



// WEBPACK FOOTER //
// ./src/features/plan/Plan_lngPage.js